// Changed the company's name to a proper legal name (AEP-54) 
export const MENTION = "Powered By IT Synergistics LLC";
